<app-card-table
    #complaintTypeTable
    [tableTitle]="'service.complaintType.title'"
    translatePrefix="service.complaintType."
    [columns]="columns"
    [defaultSorters]="{ column: 'name', direction: 'ASC' }"
    [gridData]="$any(store.data.getComplaintTypes())"
    [hideCheckboxes]="true"
    [showClearFilter]="false"
    [additionalFilter]="[[{
            column: 'serviceId',
            value: [routeParams.serviceId()],
            operator: 'EQ',
        }]]"
    [refreshCallback]="store.api.getComplaintTypes"
    [refreshCallbackFragment]="getComplaintTypeFrag"
    (deleteCallbackWithEvent)="delete($event)"
    (detailCallback)="detail($event)"
    (createCallback)="create()"
></app-card-table>
